module.exports = __webpack_public_path__ + "img/patient-sent-mess.e96259d3.svg";